import { Component,OnDestroy,Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './nonav.component.html'
})


export class NoNavLayoutComponent  implements OnDestroy {
  
    constructor(private renderer: Renderer2) {
      this.renderer.addClass(document.body, 'sidebar-hidden');
      this.renderer.addClass(document.body, 'homeBodyC');
     }
  
    ngOnDestroy() {
      this.renderer.removeClass(document.body, 'sidebar-hidden');
      this.renderer.removeClass(document.body, 'homeBodyC');
    }
  }




// WEBPACK FOOTER //
// ./src/app/containers/nonav-layout/nonav-layout.component.ts